import Qs from "qs";

import { isObject } from 'gyl-common/utils/type'

export const createLocation = (href: string): any => {
    if (isObject(href)) {
        return href
    }

    if (typeof href === 'string' && href) {
        const { origin, pathname, search } = new URL(href)

        return {
            origin,
            pathname,
            search,
            query: Qs.parse(search, { ignoreQueryPrefix: true })
        }
    }

    return {
        origin: '',
        pathname: '',
        search: '',
        query: {}
    }
}
